import React from 'react';
import { Controller } from 'react-hook-form';
import FormControl from 'presentation/components/FormControl';
import { FormValidator } from 'tools/FormValidator';
import { useTranslation } from 'react-i18next';
import Input from 'presentation/components/Input';

interface StreetFieldProps {
  formControl: any;
  errors: any;
  setValue: (name: 'street' | 'houseNr' | 'zip' | 'city', value: any) => void;
  inputRef?: React.RefObject<HTMLInputElement>;
}

const StreetField: React.FC<StreetFieldProps> = ({ formControl, errors, inputRef }) => {
  const { t } = useTranslation('translation', {
    keyPrefix: 'page.houseAddress'
  });

  return (
    <FormControl
      required
      additionalTestId="street"
      label={<span id="street-label">{t('labelStreet')}</span>}
      error={errors.street && t('errorStreet')}
      htmlFor="field-street"
    >
      <Controller
        name="street"
        control={formControl}
        rules={{
          required: true,
          validate: {
            validate: (v) => FormValidator.isValidStreet(v)
          }
        }}
        render={({ field }) => (
          <Input
            id="field-street"
            type="text"
            aria-labelledby="street-label"
            aria-required="true"
            aria-invalid={!!errors.street}
            aria-describedby={errors.street ? 'street-error' : undefined}
            inputRef={inputRef}
            {...field}
          />
        )}
      />
    </FormControl>
  );
};

export default StreetField;
